import { Circle, Page } from '@/components';
import { useSearchParams } from '@/hooks';
import { collateralColorPalette } from '@/theme/utils/collateralColorPalette';
import { Flex, Heading } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import HistoricTabs from './HistoricTabs';
import IlksTable from './IlksTable';
import KpiOverview from './KpiOverview';

export default function ObexPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const theme = useTheme();
  return (
    <Page
      title={
        <Flex gap="3xs" alignItems="center">
          <Circle
            size="3"
            color={collateralColorPalette(
              'obex',
              theme.colors.collateralColors
            )}
          />
          <Heading size="1">Obex</Heading>
        </Flex>
      }>
      <KpiOverview daysAgo={daysAgo} />
      <HistoricTabs />
      <IlksTable daysAgo={daysAgo} />
    </Page>
  );
}
